module.exports = __webpack_public_path__ + "img/background017.jpg";